import { render, staticRenderFns } from "./userMedalInfo.vue?vue&type=template&id=f5386b26"
import script from "./userMedalInfo.vue?vue&type=script&lang=js"
export * from "./userMedalInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports